import { render, staticRenderFns } from "./VLabelCombobox.vue?vue&type=template&id=c9958342&scoped=true"
import script from "./VLabelCombobox.vue?vue&type=script&lang=js"
export * from "./VLabelCombobox.vue?vue&type=script&lang=js"
import style0 from "./VLabelCombobox.vue?vue&type=style&index=0&id=c9958342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9958342",
  null
  
)

export default component.exports